<template>
  <div id="key">
    {{ key }}
  </div>
</template>

<script>
import { mapActions } from 'vuex'
import { nanoid } from 'nanoid'

export default {
  name: 'WebviewInit',

  computed: {
    key () {
      return this.$store.state.webview.key
    }
  },

  methods: {
    ...mapActions([
      'signOut'
    ]),
  },

  created () {
    this.signOut()
    this.$store.dispatch('webview/init', nanoid())
    this.$emit('loadingDone')
  }
}
</script>



// WEBPACK FOOTER //
// src/pages/webview/Init.vue